export const handleCloseEvent = ({
  setIsLivePersonSessionActive,
  setIsLivePersonEnabled,
  setCloseLpChat,
  livePersonEventSource,
  setLivePersonAgentName,
  setLivePersonAgentInitial,
  livePersonAgentNickname,
  setStreamingText,
  setCachedMessages,
  syncChatMessage,
  setLivePersonConversationId
}) => {
  setIsLivePersonSessionActive(false);
  // disable the LP feature
  setIsLivePersonEnabled(false);
  setCloseLpChat(false);
  // connection closed
  livePersonEventSource.close();
  // Clear agent name
  setLivePersonAgentName('');
  setLivePersonAgentInitial('');
  setLivePersonConversationId('');
  // display end conversation seperator
  const contentSeparatorMessage = {
    role: 'chatContentSeparator',
    content: `${livePersonAgentNickname} has disconnected from this chat.`,
    key: 'agentDisconnected'
  };
  // Clear any streaming message
  setStreamingText('');
  // showing disconnection message
  setCachedMessages(contentSeparatorMessage);
  setCachedMessages({
    role: 'lpChatDisclosure',
    content: 'You will be transferred back to Penny, our AI travel assistant. Please do not include any personal information in the chat.'
  });
  setCachedMessages({
    role: 'chatContentSeparator',
    content: `You are connected to Penny now.`,
    key: 'pennyConnected'
  });
  syncChatMessage();
};